module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADGSURBVHgB3ZYBCsIwDEX/9CCKHkDwDJ5P6AGEHUTP4m4SW4yulLVLWsjGPgRK2+SNtMnaEdEeBtrBSIuBLt7u3o6o18Hbg2ONCmcUWU9fvb2dkzWJndg3yMVrKGzUwoq+0DrUQHIgLUy0F40BxB+EhpSoUjwHygVUn2NHshYUauPF9TXw3G98i+aykoJSGDSQoNX1ujR1A4+fkLYrq8uwiuttUrAmLcikqZr9JlwlZArWl0BX3lADiWGOY/3nNS2oSdt7bn0AFaj9k4PUnCkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mIndexClose.png
// module id = VWG9
// module chunks = 1